// extracted by mini-css-extract-plugin
export var basicImageWithTextContainer = "index-module--basicImageWithTextContainer--95Xmt";
export var basicImageWithTextFlexContainer = "index-module--basicImageWithTextFlexContainer--kKn+0";
export var basicImageWithTextFrontImage = "index-module--basicImageWithTextFrontImage--6H1vf";
export var basicImageWithTextHeadingContainer = "index-module--basicImageWithTextHeadingContainer--bJw5a";
export var basicImageWithTextLeft = "index-module--basicImageWithTextLeft--hESNb";
export var basicImageWithTextRight = "index-module--basicImageWithTextRight--5XRCV";
export var basicImageWithTextSubtext = "index-module--basicImageWithTextSubtext--DfFqs";